import BrandLogo from '../BrandLogo';

/** Shared attribution on public, recipient-facing experiences. */
export default function GeneratedByFooter() {
  return (
    <footer className="mt-6 flex justify-center border-t border-slate-200 py-5">
      <a
        href="/"
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-2 rounded px-1 py-0.5 text-xs text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800"
        aria-label="Generated using MyDocUploads"
      >
        <span>Generated using</span>
        <BrandLogo className="h-5 w-auto" alt="MyDocUploads" to={null} />
      </a>
    </footer>
  );
}
